import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d2b2dd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-data" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "custom-tabs-label" }
const _hoisted_4 = { class: "custom-tabs-label" }
const _hoisted_5 = { class: "custom-tabs-label" }

import { ref } from 'vue'
import DeviceInfo from './components/device-info.vue'
import DeviceVarTable from './components/device-var-table.vue'
import DeviceMap from './components/device-map.vue'
import { isEmpty } from 'lodash'
import { deviceDetail } from '@/api'
import { useRouter, useRoute } from 'vue-router'
import { CODE_ENUM } from '@/common'
import VarList from './components/var-list.vue'
import SubDeviceTable from './components/sub-device-table.vue'
import RecordTable from './components/record-table.vue'
import WarningTable from './components/warning-table.vue'
import { useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const authStore = useAuthStore()

const validateAuth = (code: string) => {
  return authStore.resources.includes(code)
}

const activeName = ref('first')

const router = useRouter()
const $route = useRoute()
const deviceId = $route.query.deviceId || ''

const deviceMapRef = ref()

const deviceData: any = ref({})
const queryDetail = async () => {
  const res: any = await deviceDetail({
    deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceData.value = res.data

    const data = res.data
    setTimeout(() => {
      if (!isEmpty(data.deviceLocationInfo)) {
        deviceMapRef.value.createMaker(data.deviceLocationInfo)
      }
    }, 500)
  }
}

queryDetail()

const toStatisticsHistory = (query: any) => {
  const { code, value } = query
  if (value === null) {
    return
  }
  router.push({
    name: 'statistics-history',
    query: {
      deviceId,
      orgId: deviceData.value.topOrgId,
      subDeviceId: query.deviceId,
      code,
    },
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DeviceInfo, { data: deviceData.value }, null, 8, ["data"]),
      _createVNode(DeviceMap, {
        ref_key: "deviceMapRef",
        ref: deviceMapRef
      }, null, 512)
    ]),
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
      class: "tabs ws_mt16"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { name: "first" }, {
          label: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('D_DATA.varTitle')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(VarList, { onOnData: toStatisticsHistory })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "first1" }, {
          label: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('D_DATA.subDevice')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(SubDeviceTable)
          ]),
          _: 1
        }),
        (validateAuth('3-2'))
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              name: "first2"
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('D_DATA.alarmMsg')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(WarningTable)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})